import { ChangeDetectionStrategy, Component, OnChanges, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Requisition } from 'projects/requisition-management/src/app/models/requisition/requisition.model';

import { Basket } from 'ish-core/models/basket/basket.model';
import { Bucket } from 'ish-core/models/bucket/bucket.model';
import { Order } from 'ish-core/models/order/order.model';
import { PipesModule } from 'ish-core/pipes.module';
import { RecurringOrder } from 'ish-core/models/recurring-order/recurring-order.model';

@Component({
  selector: 'ish-basket-shipping-method',
  templateUrl: './basket-shipping-method.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, PipesModule],
})
export class BasketShippingMethodComponent implements OnChanges {
  readonly data = input.required<Basket | Order | Requisition | RecurringOrder>();
  readonly shippingBucket = input<Bucket>();

  desiredDeliveryDate: string;

  ngOnChanges(): void {
    this.desiredDeliveryDate = this.data().attributes?.find(attr => attr.name === 'desiredDeliveryDate')
      ?.value as string;
  }
}
